
import React from 'react';
import OriginsSettings from '../features/settings/origins/OriginsSettings';

const OriginsSettingsPage: React.FC = () => {
    return <OriginsSettings />;
};

export default OriginsSettingsPage;
